/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { AssociationType } from 'app/shared/model/enumerations/association-type.model';
import { createEntity, getEntity, reset, updateEntity } from './doctor-diaglab-association.reducer';

export const DoctorDiaglabAssociationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const doctorDiaglabAssociationEntity = useAppSelector(state => state.doctorDiaglabAssociation.entity);
  const loading = useAppSelector(state => state.doctorDiaglabAssociation.loading);
  const updating = useAppSelector(state => state.doctorDiaglabAssociation.updating);
  const updateSuccess = useAppSelector(state => state.doctorDiaglabAssociation.updateSuccess);
  const associationTypeValues = Object.keys(AssociationType);

  const handleClose = () => {
    navigate(`/doctor-diaglab-association${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getDiagLabs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.joiningDate !== undefined && typeof values.joiningDate !== 'number') {
      values.joiningDate = Number(values.joiningDate);
    }
    if (values.leavingDate !== undefined && typeof values.leavingDate !== 'number') {
      values.leavingDate = Number(values.leavingDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...doctorDiaglabAssociationEntity,
      ...values,
      doctor: doctors.find(it => it.id.toString() === values.doctor?.toString()),
      lab: diagLabs.find(it => it.id.toString() === values.lab?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          association: 'PATHOLOGY',
          ...doctorDiaglabAssociationEntity,
          doctor: doctorDiaglabAssociationEntity?.doctor?.id,
          lab: doctorDiaglabAssociationEntity?.lab?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.doctorDiaglabAssociation.home.createOrEditLabel" data-cy="DoctorDiaglabAssociationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.doctorDiaglabAssociation.home.createOrEditLabel">
              Create or edit a DoctorDiaglabAssociation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="doctor-diaglab-association-id"
                  label={translate('tinyMedicRestApp.doctorDiaglabAssociation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.joiningDate')}
                id="doctor-diaglab-association-joiningDate"
                name="joiningDate"
                data-cy="joiningDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.leavingDate')}
                id="doctor-diaglab-association-leavingDate"
                name="leavingDate"
                data-cy="leavingDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.dutyStartTime')}
                id="doctor-diaglab-association-dutyStartTime"
                name="dutyStartTime"
                data-cy="dutyStartTime"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.dutyEndTime')}
                id="doctor-diaglab-association-dutyEndTime"
                name="dutyEndTime"
                data-cy="dutyEndTime"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.permanent')}
                id="doctor-diaglab-association-permanent"
                name="permanent"
                data-cy="permanent"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.active')}
                id="doctor-diaglab-association-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.cursor')}
                id="doctor-diaglab-association-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.lastUpdated')}
                id="doctor-diaglab-association-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.microSec')}
                id="doctor-diaglab-association-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.timestampEntry')}
                id="doctor-diaglab-association-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.association')}
                id="doctor-diaglab-association-association"
                name="association"
                data-cy="association"
                type="select"
              >
                {associationTypeValues.map(associationType => (
                  <option value={associationType} key={associationType}>
                    {translate(`tinyMedicRestApp.AssociationType.${associationType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="doctor-diaglab-association-doctor"
                name="doctor"
                data-cy="doctor"
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.doctor')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="doctor-diaglab-association-lab"
                name="lab"
                data-cy="lab"
                label={translate('tinyMedicRestApp.doctorDiaglabAssociation.lab')}
                type="select"
                required
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/doctor-diaglab-association" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DoctorDiaglabAssociationUpdate;
